import { colors } from './colors';
import { fonts } from './fonts';
import { spacing } from './spacing';

export const theme = { colors, fonts, spacing };
export { colors, fonts, spacing };